import { SwiperSlide } from "swiper/react";
import { Container, Title, Carousel } from "../../../shared/ui";
import { DirectionCard, DirectionCardSkeleton, useGetDirectionsQuery } from "../../../entities/Direction";

import { useMediaQuery } from "../../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../shared/constants/media";

import type { ReactElement, CSSProperties } from "react";

import styles from "./CollectionJobs.module.scss";

export const CollectionJobs = () => {
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));
    const { data: directionList, isLoading, isSuccess } = useGetDirectionsQuery();

    let content: ReactElement[] | null = null;

    if (isLoading) {
        content = [...Array(12)].map((_, index) => (
            <SwiperSlide key={index} className={styles.slide}>
                <DirectionCardSkeleton />
            </SwiperSlide>
        ));
    }

    if (isSuccess) {
        content = directionList.map((job) => (
            <SwiperSlide key={job.id} className={styles.slide}>
                <DirectionCard itemJob={job} />
            </SwiperSlide>
        ));
    }

    return (
        <div>
            <Container marginSize="standard">
                <Title level={3} className={styles.title}>
                    Работа для тех, кто всегда хочет большего
                </Title>
            </Container>
            <Container className={styles.jobSwiper} marginSize={!isMobile ? "standard" : undefined}>
                <Carousel
                    className={styles.jobSwiper__carousel}
                    style={{ "--space-between-slide": isMobile ? "0" : "20px" } as CSSProperties}
                    loop={false}
                    spaceBetween={isMobile ? 0 : 20}
                    slidesOffsetBefore={isMobile ? 20 : 0}
                    slidesOffsetAfter={isMobile ? 20 : 0}
                    navigation="down"
                    navigationTheme="light"
                >
                    {content}
                </Carousel>
            </Container>
        </div>
    );
};
